import React from "react";
import styles from "./ota-drawer-info.module.scss";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import IconBuilding from "@src/assets/svg/icon-building.svg";
import UserProfileIcon from "@src/assets/svg/user-profile-icon.svg";
import SourceIcon from "@src/assets/svg/source-icon.svg";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { useI18N } from "@src/language/language-context";
const cssClassName = "ota-drawer-info";
const OtaDrawerInfo = () => {
  const connectionView = useSelector(
    (state: RootState) => state.yourSlice?.connectionView,
  );
  const authContext = useSelector(
    (state: RootState) => state.yourSlice?.authContext,
  );
  const i18n = useI18N();
  const texts = {
    providedForText: i18n("modules.otaDrawerInfo.providedForText"),
    machineText: i18n("modules.otaDrawerInfo.machineText"),
    uploaderText: i18n("modules.otaDrawerInfo.uploaderText"),
    buildingAltText: i18n("modules.otaDrawerInfo.buildingAltText"),
    uploaderAltText: i18n("modules.otaDrawerInfo.uploaderAltText"),
  };
  return (
    <FlexColumnContainer>
      <div className={styles[`${cssClassName}__session-label`]}>
        {texts.providedForText}
      </div>
      <div className={styles[`${cssClassName}__detail-item`]}>
        <img src={IconBuilding} alt={texts.buildingAltText} />
        <span>{authContext?.organization}</span>
      </div>

      <div className={styles[`${cssClassName}__session-section`]}>
        <div className={styles[`${cssClassName}__session-label`]}>
          {texts.machineText}
        </div>
        <span className={styles[`${cssClassName}__detail-value`]}>
          <img
            src={SourceIcon}
            alt={texts.machineText}
            className={styles[`${cssClassName}__source-icon`]}
          />
          <span className={styles[`${cssClassName}__info-text`]}>
            {connectionView?.source?.name}
          </span>
        </span>
      </div>

      <>
        <div className={styles[`${cssClassName}__session-label`]}>
          {texts.uploaderText}
        </div>
        <div className={styles[`${cssClassName}__detail-item`]}>
          <img src={UserProfileIcon} alt={texts.uploaderAltText} />
          <span>{authContext?.fullName}</span>
        </div>
      </>
    </FlexColumnContainer>
  );
};

export default OtaDrawerInfo;
